import { render } from "./InterviewLink.vue?vue&type=template&id=1668c0ae"
import script from "./InterviewLink.vue?vue&type=script&lang=js"
export * from "./InterviewLink.vue?vue&type=script&lang=js"

import "./InterviewLink.vue?vue&type=style&index=0&id=1668c0ae&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__